module.exports = __webpack_public_path__ + "46f2b485321b1a4d3ce1e94bd841e9de.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/one-way-exchange-unread.svg
// module id = 109
// module chunks = 0